import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Property entitity form
 */

export class PropertyEntityForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Тип сущности',
      name: 'type'
    }, {
      label: 'ID сущности',
      name: 'entityId'
    }, {
      label: 'Тип отображения',
      name: 'viewType'
    }, {
      label: 'Группа характеристики',
      name: 'groupId',
      type: BaseForm.TYPES.AUTOCOMPLETE,
      props: {
        common: {
          dataState: StateSelector.properties.propertiesGroups.list,
          dataFetch: DispatchSelector.properties.propertiesGroups.list,
          searchFilter: value => ({
            title: {
              like: `%${value}%`
            }
          }),
          valueColumn: 'id',
          labelColumn: 'title'
        }
      }
    }, {
      label: 'Значение',
      name: 'viewValue'
    }];
    this.dispatchCreateForm = DispatchSelector.properties.propertiesEntities.create;
    this.dispatchUpdateForm = DispatchSelector.properties.propertiesEntities.update;
    this.responseCreateState = StateSelector.properties.propertiesEntities.create;
    this.responseUpdateState = StateSelector.properties.propertiesEntities.update;
  }

}